<mat-toolbar class="header">
  <div class="header__title">
    <div
      style="display: flex; flex-direction: row; cursor: pointer"
      (click)="navigateHome()"
    >
      <img
        [src]="
          'data:image/png;base64,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'
        "
        alt="logo"
        style="display: inline"
        class="rounded"
        class="header__title-text"
        height="38"
        width="44"
      />
      <h3 style="color: white; padding-left: 5%; font-size: 1.8em">Speetals</h3>
    </div>
  </div>
</mat-toolbar>
<mat-card appearance="outlined"> </mat-card>
<mat-card appearance="outlined"></mat-card>

<div *ngIf="!showResult">
  <mat-card appearance="outlined">
    <h2>Test your domain</h2>
  </mat-card>
  <mat-horizontal-stepper [linear]="!isLinear" #stepper>
    <mat-step [stepControl]="firstFormGroup" *ngIf="!edit">
      <form [formGroup]="firstFormGroup">
        <ng-template matStepLabel>Domain and monitoring</ng-template>
        <mat-card-header>
          <mat-card-title>Website and monitoring information:</mat-card-title>
        </mat-card-header>
        <div class="row">
          <div class="col">
            <mat-form-field class="full-width">
              <input
                *ngIf="!edit"
                matInput
                placeholder="Website name"
                formControlName="title"
                autofocus
              />
              <input
                *ngIf="edit && i === 0"
                [(ngModel)]="editWebsite.title"
                matInput
                placeholder="Website name"
                formControlName="title"
                readonly
              />
              <mat-error
                *ngIf="firstFormGroup.controls['title'].hasError('required')"
              >
                Website name is <strong>required</strong>
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col">
          <mat-form-field class="full-width">
            <mat-label>Domain name</mat-label>
            <input
              *ngIf="!edit"
              matInput
              placeholder="https://www.example.com"
              formControlName="domain"
              type="url"
            />
            <input
              *ngIf="edit && i === 0"
              [(ngModel)]="editWebsite.originDomain"
              matInput
              placeholder="Website domain"
              formControlName="domain"
              type="url"
              readonly
            />
            <mat-error
              *ngIf="firstFormGroup.controls['domain'].hasError('required')"
            >
              Domain is <strong>required</strong>
            </mat-error>
            <mat-error
              *ngIf="firstFormGroup.controls['domain'].hasError('pattern')"
            >
              Please provide a valid domain name
              <strong>(absolute URL, without a trailing slash)</strong>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="from">
          <button mat-button class="bou" [routerLink]="['/home']">
            Cancel
          </button>

          <button mat-raised-button color="primary" matStepperNext>Next</button>
        </div>
      </form>
    </mat-step>
    <!-- secondFormGroup : Internal Url && name -->

    <mat-step [stepControl]="secondFormGroup" label="Internal pages">
      <!-- #enddocregion label -->
      <form [formGroup]="secondFormGroup">
        <div id="internalUrls">
          <mat-card-header>
            <mat-card-title>Internal pages information:</mat-card-title>
            <mat-card-subtitle
              >From your top internal pages, enter one from each page type
              (product page, category, search page,
              cart..etc)</mat-card-subtitle
            >
            <mat-card-subtitle
              >Don't add your homepage, it will per default
              analyzed.</mat-card-subtitle
            >
          </mat-card-header>
          <section
            class="container border mb-4 p-3"
            formArrayName="internalUrls"
            *ngFor="let item of internalUrlControls; let i = index"
          >
            <div [formGroupName]="i">
              <!-- <p style="color:red;">Duplicate Name </p> -->
              <div class="row">
                <div class="col-6">
                  <h4>Page {{ i + 1 }} name</h4>
                </div>
                <div class="col-6 text-right">
                  <button
                    type="button"
                    mat-raised-button
                    color="warn"
                    style="margin-right: 10px"
                    (click)="removeInternalUrl(i)"
                    *ngIf="i > 0"
                  >
                    Remove this internal page
                  </button>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <mat-form-field class="full-width">
                    <input
                      *ngIf="!addCount(i)"
                      matInput
                      placeholder="Page name"
                      formControlName="title"
                      autofocus
                    />
                    <input
                      *ngIf="addCount(i) && !editDataLoading"
                      [(ngModel)]="intUrl.title"
                      matInput
                      placeholder="page name"
                      formControlName="title"
                      readonly
                    />
                  </mat-form-field>
                  <mat-error
                    *ngIf="item.controls.title.hasError('required') && validIn"
                  >
                    Page name is <strong>required</strong>
                  </mat-error>
                  <mat-error *ngIf="item.controls.title.hasError('unique')">
                    Please don't provide <strong>duplicate </strong> URL
                  </mat-error>
                </div>
                <div class="col-6">
                  <mat-form-field class="full-width">
                    <input
                      *ngIf="!addCount(i)"
                      placeholder="https://www.example.com/page"
                      matInput
                      placeholder="Page URL"
                      formControlName="url"
                      autofocus
                    />
                    <input
                      *ngIf="addCount(i) && !editDataLoading"
                      placeholder="https://www.example.com/page"
                      [(ngModel)]="intUrl.url"
                      matInput
                      placeholder="page url"
                      formControlName="url"
                      readonly
                    />
                  </mat-form-field>
                  <mat-error *ngIf="item.controls.url.hasError('pattern')">
                    Please provide <strong>valid</strong> URL
                  </mat-error>
                  <mat-error *ngIf="item.controls.url.hasError('unique')">
                    Please don't provide <strong>duplicate </strong> URL
                  </mat-error>
                  <mat-error
                    *ngIf="item.controls.url.hasError('required') && validIn"
                  >
                    Internal page URL is <strong>required</strong>
                  </mat-error>
                  <mat-error *ngIf="item.controls.url.errors?.belongErrors">
                    Internal page url must be belong in Origin Domain
                  </mat-error>
                  <mat-error
                    class="invalid-feedback"
                    *ngIf="item.controls.url.errors?.diffErrors"
                  >
                    Internal page url must be different of origin Domain
                  </mat-error>
                </div>
              </div>

              <!-- <h2>Debug</h2>
                <ul>
                  <li>Is my form  valid? {{item.controls.valid}}</li>
                  <li><pre>{{item.controls.url.errors | json}}</pre></li>
                </ul> -->
            </div>
          </section>
        </div>
        <div>
          <button mat-button matStepperPrevious class="bou">Back</button>
          <button
            mat-raised-button
            color="primary"
            matStepperNext
            (click)="validInternal()"
          >
            Next
          </button>
        </div>
      </form>
    </mat-step>

    <!-- thirdFormGroup : competitor Url && name -->

    <mat-step [stepControl]="thirdFormGroup" label="Competition">
      <form [formGroup]="thirdFormGroup">
        <div id="competitions">
          <mat-card-title
            >Who is faster, you or your competitors?</mat-card-title
          >
          <mat-card-subtitle
            >Add your main competitors websites</mat-card-subtitle
          >
          <section
            class="container border mb-4 p-3"
            formArrayName="competitors"
            *ngFor="let item of competitorControls; let i = index"
          >
            <div [formGroupName]="i">
              <div class="row">
                <div class="col-6">
                  <h4>Competitor {{ i + 1 }}</h4>
                </div>
                <div class="col-6 text-right">
                  <button
                    type="button"
                    mat-raised-button
                    color="warn"
                    style="margin-right: 10px"
                    *ngIf="i > 0"
                    (click)="removeCompetitor(i)"
                  >
                    Remove competitor
                  </button>
                </div>
              </div>

              <div class="row">
                <div class="col-6">
                  <mat-form-field class="full-width">
                    <input
                      *ngIf="!addCount(i)"
                      matInput
                      placeholder="Competitor Name"
                      formControlName="title"
                      autofocus
                    />
                    <input
                      *ngIf="addCount(i) && !editDataLoading"
                      [(ngModel)]="compet.title"
                      matInput
                      placeholder="page name"
                      formControlName="title"
                      readonly
                    />
                  </mat-form-field>
                  <mat-error
                    *ngIf="
                      item.controls.title.hasError('required') && validComp
                    "
                  >
                    Name is <strong>required</strong>
                  </mat-error>
                </div>
                <div class="col-6">
                  <mat-form-field class="full-width">
                    <input
                      *ngIf="!addCount(i)"
                      placeholder="https://www.example.com/page"
                      matInput
                      placeholder="Competitor domain"
                      formControlName="url"
                      autofocus
                    />
                    <input
                      *ngIf="addCount(i) && !editDataLoading"
                      placeholder="https://www.example.com/page"
                      [(ngModel)]="compet.url"
                      matInput
                      placeholder="page url"
                      formControlName="url"
                      readonly
                    />
                  </mat-form-field>
                  <mat-error *ngIf="item.controls.url.hasError('pattern')">
                    Please provide a valid domain name
                    <strong>(absolute URL, without a trailing slash)</strong>
                  </mat-error>
                  <mat-error *ngIf="item.controls.url.hasError('unique')">
                    Please don't provide <strong>duplicate </strong> competitor
                  </mat-error>
                  <mat-error
                    *ngIf="item.controls.url.hasError('required') && validComp"
                  >
                    Competitor domain is <strong>required</strong>
                  </mat-error>
                  <mat-error
                    class="invalid-feedback"
                    *ngIf="item.controls.url.errors?.diffErrors"
                  >
                    Competition Url must be different of origin Domain
                  </mat-error>
                </div>
              </div>
            </div>
          </section>
        </div>
        <div>
          <button mat-button matStepperPrevious class="bou">Back</button>
          <button
            mat-raised-button
            color="primary"
            matStepperNext
            (click)="validCompetitor()"
          >
            Next
          </button>
        </div>
      </form>
    </mat-step>

    <!-- Done  :  Recap of data && Boutton let's go -->

    <mat-step>
      <ng-template matStepLabel>Summary</ng-template>
      <div style="text-align: center">
        <mat-card-title>Almost finished!</mat-card-title>
        <mat-card-subtitle
          >Please check what you entered as information. If all looks good to
          you, press the <strong>"let's go"</strong> button and let the magic
          begin!
        </mat-card-subtitle>
        <mat-card-subtitle>You can go back to modify!</mat-card-subtitle>

        <h2>Website:</h2>
        Name: {{ websiteAnalyze.title }} | Url:
        {{ websiteAnalyze.originDomain }}

        <mat-divider></mat-divider>
        <h2>Internal pages:</h2>
        <span *ngFor="let int of websiteAnalyze.internalURLs">
          <span> Name: {{ int.title }} || URL: {{ int.url }}</span
          ><br />
        </span>
        <mat-divider></mat-divider>
        <h2>Competitors:</h2>
        <span *ngFor="let comp of websiteAnalyze.competitors">
          <span></span> Name: {{ comp.title }} || URL: {{ comp.url }}
        </span>
        <!-- <li *ngFor="let int of websiteAnalyze.competitorsTitle">
              <span></span> Name : {{int}}
            </li> -->
      </div>
      <div>
        <button mat-button matStepperPrevious class="bou">Back</button>
        <button
          mat-raised-button
          color="primary"
          [disabled]="!subBut"
          (click)="newPage()"
        >
          Let's go
        </button>
      </div>
    </mat-step>
  </mat-horizontal-stepper>
</div>

<div *ngIf="showResult">
  <mat-card appearance="outlined" style="text-align: center"
    ><mat-card-title> Metrics result of your domain {{ websiteAnalyze.originDomain }}</mat-card-title>
    <button
      *ngIf="accessToken"
      style="text-align: center"
      mat-raised-button
      (click)="saveData()"
      [disabled]="saving"
    >
      Save your data
    </button>
    <button
      *ngIf="!accessToken"
      style="text-align: center"
      mat-raised-button
      (click)="signupAndSaveData()"
    >
      Click here to sign/signup and save your data
    </button>
  </mat-card>
  <div>
    <!-- <app-device-button (deviceEvent)='setDevice($event)'></app-device-button> -->

    <section class="example-section">
      <label class="example-margin">Device :<i class="pe"> ' ' </i></label>
      <mat-radio-group
        [(ngModel)]="device"
        (change)="setDeviceUrl($event)"
        labelPosition="before"
      >
        <mat-radio-button class="example-margin" value="mobile"
          >Mobile
        </mat-radio-button>
        <mat-radio-button class="example-margin" value="desktop"
          >Desktop</mat-radio-button
        >
      </mat-radio-group>
    </section>
  </div>
  <mat-divider></mat-divider>

  <div>
    <mat-card appearance="outlined" class="text-center">
      <mat-card-title
        >Domain-level data for the previous 28-day period</mat-card-title
      >
      <mat-card-subtitle
        ><p>
          Over the previous 28-day collection period, field data shows that this
          domain <FONT [color]="color"> {{ status }} </FONT> the Core Web Vitals
          assessment.
        </p></mat-card-subtitle
      >
      <mat-card-subtitle *ngIf="!passOrNot"
        >Each Web Vitals metric should at least reach 75% of Good<br />
      </mat-card-subtitle>

      <mat-card-subtitle
        *ngIf="printUxr(result.uxr)"
        matTooltip="UXR: User eXperience Rating assess real users’ experiences."
      >
        <circle-progress
          title="UXR"
          subtitle="{{ result.uxr }}%"
          percent="{{ result.uxr }}"
        ></circle-progress>
        <span
          class="my-custom-badge-accent"
          matBadge="{{ result.uxrDiff }}"
          [matBadgeHidden]="result.uxrDiff === 0"
          [matBadgeColor]="getBadgeColor(result.uxrDiff)"
         matBadgePosition="after"
          matBadgeOverlap="false"
        >
        </span>
      </mat-card-subtitle>
    </mat-card>
    <mat-grid-list *ngIf="!Alldevice" class="mat-grid" cols="3" rowHeight="7:6">
      <!--
        change value of rowHeight to have the right gap
        row height value is a division
      -->
      <mat-grid-tile *ngFor="let metric of metrics">
        <div class="col-sm">
          <div class="title">
            <img
              *ngIf="!chartOptions[metric]?.hasNoData"
              alt="Metric"
              loading="lazy"
              width="23"
              height="18"
              [src]="title[metric]"
              alt="{{ metric }}+ image"
              class="rounded"
            />

            <p *ngIf="chartOptions[metric]?.hasNoData">
              No
              <strong [matTooltip]="result[metric].description">
                {{ result[metric].name }} <i class="pe"> '' </i>
              </strong>
              data
            </p>

            <strong
              *ngIf="!chartOptions[metric]?.hasNoData"
              [matTooltip]="result?.[metric]?.description"
            >
              {{ result?.[metric]?.name }} <i class="pe"> '' </i>
            </strong>

            <span
              *ngIf="!chartOptions[metric]?.hasNoData"
              [matTooltip]="descriptionDiff(metric)"
            >
              Diff:
            </span>
            <span
              class="my-custom-badge-accent stretch-badge"
              matBadge="{{ result?.[metric]?.diff }}%"
              [matBadgeHidden]="result?.[metric]?.diff === 0"
              [matBadgeColor]="getBadgeColor(result?.[metric]?.diff)"
             matBadgePosition="after"
              matBadgeOverlap="false"
            >
            </span>
          </div>

          <apx-chart
            *ngIf="!chartOptions[metric]?.hasNoData"
            [series]="chartOptions[metric].series"
            [chart]="chartOptions[metric].chart"
            [dataLabels]="chartOptions[metric].dataLabels"
            [plotOptions]="chartOptions[metric].plotOptions"
            [xaxis]="chartOptions[metric].xaxis"
            [yaxis]="chartOptions[metric].yaxis"
            [stroke]="chartOptions[metric].stroke"
            [fill]="chartOptions[metric].fill"
            [tooltip]="chartOptions[metric].tooltip"
            [legend]="chartOptions[metric].legend"
          >
          </apx-chart>
        </div>
      </mat-grid-tile>
    </mat-grid-list>
  </div>
</div>
